import { api } from "@/lib/api";

// One API shape for every LSO track: the franchisee self-course, a franchisee's employee, and the rental course.
export function lsoTrack(kind, as = "me") {
  if (kind === "rental") {
    const base = "/lso-rental/enrollments/me";
    return {
      kind, as: "me", hubPath: "/lso-course", certValidity: 90,
      getCourse: () => api("/lso-rental/course"),
      start: () => api("/lso-rental/enrollments/start", { method: "POST", body: {} }),
      acceptWaiver: (acks) => api("/lso-rental/waiver", { method: "POST", body: acks }),
      completeLesson: (n) => api(`${base}/module/${n}/lesson`, { method: "POST", body: { done: true } }),
      submitQuiz: (n, answers) => api(`${base}/module/${n}/quiz`, { method: "POST", body: { answers } }),
      submitFinal: (answers) => api(`${base}/final-exam`, { method: "POST", body: { answers } }),
      getCertificate: () => api(`${base}/certificate`),
      getStatus: () => api("/lso-rental/status/me").catch(() => null),
    };
  }
  const base = as === "me" ? "/lso/enrollments/me" : `/lso/employees/${as}`;
  const unwrap = (r) => r.enrollment || r;
  return {
    kind, as, hubPath: "/lso", certValidity: 365,
    getCourse: () => api("/lso/course"),
    start: () => api(as === "me" ? "/lso/enrollments/start" : `${base}/start`, { method: "POST" }).then(unwrap),
    completeLesson: (n) => api(`${base}/module/${n}/complete-lesson`, { method: "POST" }),
    submitQuiz: (n, answers) => api(`${base}/module/${n}/quiz`, { method: "POST", body: { answers } }),
    submitFinal: (answers) => api(`${base}/final-exam`, { method: "POST", body: { answers } }),
    getCertificate: () => api(`${base}/certificate`),
    getStatus: () => (as === "me" ? api("/lso/status/me").catch(() => null) : Promise.resolve(null)),
  };
}

export const passedCount = (e) => (e?.modules_progress || []).filter((m) => m.quiz_passed).length;

export function nextModule(e, total) {
  const passed = new Set((e?.modules_progress || []).filter((m) => m.quiz_passed).map((m) => m.module_number));
  for (let n = 1; n <= total; n++) if (!passed.has(n)) return n;
  return total;
}

export const canTakeFinal = (e, total) => passedCount(e) >= Math.min(10, total);

export const qs = (as) => (as && as !== "me" ? `?as=${encodeURIComponent(as)}` : "");

export function downloadPdf(base64, filename) {
  // Backend stores PDFs as a data URL ("data:application/pdf;base64,...") — strip the prefix before decoding.
  const bytes = Uint8Array.from(atob(String(base64).split(",").pop()), (c) => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  return (m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(iso)).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
};
